import Component from '../component';

export default class FormEditAvatar extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$avatarInput = this.$element.find('.form-profile-avatarConfiguration');
    this.$avatarPreview = this.$element.find('.form-profile-avatar');
    this.$deleteButton = this.$element.find('.form-profile-avatar-delete');

    this.$editElement = this.$element.find('.formEditAvatar--edit');
    this.$deleteElement = this.$element.find('.formEditAvatar--delete');

    this.$cancelButton = this.$deleteElement.find('.btn-default');
    this.$confirmButton = this.$deleteElement.find('.btn-primary');

    this.bindEvents();
  }

  bindEvents() {
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleConfirmClick = this.handleConfirmClick.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);

    this.$cancelButton.on('click', this.handleCancelClick);
    this.$confirmButton.on('click', this.handleConfirmClick);
    this.$deleteButton.on('click', this.handleDeleteClick);
  }

  unbindEvents() {
    this.$cancelButton.off('click', this.handleCancelClick);
    this.$confirmButton.off('click', this.handleConfirmClick);
    this.$deleteButton.off('click', this.handleDeleteClick);
  }

  handleDeleteClick() {
    this.$deleteButton.addClass('highlighted');
    this.$editElement.hide();
    this.$deleteElement.addClass('shown');
  }

  handleCancelClick() {
    this.$deleteButton.removeClass('highlighted');
    this.$editElement.show();
    this.$deleteElement.removeClass('shown');
  }

  handleConfirmClick() {
    this.$avatarInput.val(null);
    // Reset preview to default avatar
    this.$avatarPreview.attr('src', this.$avatarPreview.data('default-url'));

    $('.form-profile-avatar-preview-wrapper').hide();
    $('.form-profile-avatar-wrapper').show();

    this.$deleteButton.removeClass('highlighted');
    this.$editElement.show();
    this.$deleteElement.removeClass('shown');
  }
}
